<template>
  <div :class="!hideProductListAndButtons ? 'h-full' : ''">
    <pdl-collapse
      :default-active="viewBreakpointMoreThan('small')"
      header-classes="text-md"
      class="mb-2"
      :header-level="2"
    >
      <pdl-collapse-item>
        <template #title>
          <div>
            <span id="cart-summary" class="font-bold text-lg header">{{ $t('myCart.B2B.cartSummary') }}</span>
            <span class="text-gray-60 text-md font-normal">{{ `(${cartData.code})` }}</span>
          </div>
        </template>
        <div class="content">
          <cart-item-list
            v-if="!hideProductListAndButtons"
            :is-e-comm-available="false"
            :cart-entries="cartEntries"
            :cart-data="cartData || {}"
            :is-quantity-control-enabled="false"
          />
          <div v-if="!hideProductListAndButtons" class="mt-2 md:hidden">
            <pdl-link button tertiary icon="chevron_left" icon-left :href="cartUrl" qaid="back-to-cart-link">
              {{ $t('pickup.mobile.back.to.cart.page') }}
            </pdl-link>
          </div>
          <aside-cart-totals :cart-data="cartData" :is-calculated-tax-visible="isCalculatedTaxVisible" />
        </div>
      </pdl-collapse-item>
    </pdl-collapse>
    <div class="md:block md:sticky md:top-16" :class="!hideProductListAndButtons ? 'hidden' : ''">
      <div v-if="!hideProductListAndButtons" class="grid grid-flow-row gap-y-2 mb-8">
        <checkout-submit-button
          v-if="stepId === CheckoutStep.PAYMENT_METHOD"
          :step-id="stepId"
          :card-type="paymentCardType"
          :is-new-payment="isNewPayment"
        />
        <pdl-button
          v-if="stepId === CheckoutStep.DELIVERY_ADDRESS"
          block
          primary
          type="submit"
          qaid="choose-payment-method-button"
          form="trekAddressForm"
        >
          {{ $t('checkout.summary.select.payment.method') }}
        </pdl-button>
        <pdl-link
          button
          tertiary
          block
          icon="chevron_right"
          qaid="checkout-continue-link"
          icon-right
          :href="continueShoppingUrl"
        >
          {{ $t('text.continue.shopping') }}
        </pdl-link>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex';
import {PdlButton} from '@pedal/pdl-button';
import {PdlCollapse, PdlCollapseItem} from '@pedal/pdl-collapse';
import {PdlLink} from '@pedal/pdl-link';
import AsideCartTotals from '@/components/checkout/order-summary-aside/AsideCartTotals.vue';
import CartItemList from '@/components/cart/b2c/CartItemList.vue';
import CheckoutSubmitButton from '../fields/CheckoutSubmitButton.vue';
import trackCheckout from '@/mixins/tracking/track-checkout.js';
import UserOccApi from '@/api/user-occ.js';
import {CheckoutStep} from '@/constants/checkout';

export default {
  components: {CartItemList, CheckoutSubmitButton, PdlButton, PdlCollapse, PdlCollapseItem, PdlLink, AsideCartTotals},
  mixins: [trackCheckout],
  props: {
    isNewAddress: {
      type: Boolean,
      default: false,
    },
    cartData: {
      type: Object,
      required: true,
    },
    isPaymentMethodVisible: {
      type: Boolean,
      default: true,
    },
    isCalculatedTaxVisible: {
      type: Boolean,
      default: true,
    },
    hideProductListAndButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CheckoutStep,
    };
  },
  computed: {
    ...mapState('backend', ['trekBrandNavURL']),
    ...mapState('checkout', ['paymentData', 'continueShoppingUrl']),
    ...mapState('user', ['trekUCompetencyLevel']),
    ...mapGetters('viewSize', ['viewBreakpointMoreThan']),
    ...mapGetters('checkout', ['isRestrictedToRetailer']),
    ...mapGetters('backend', ['occUrlParams']),

    paymentCardType() {
      return this.paymentData?.cardType;
    },
    cartEntries() {
      return this.cartData?.entries;
    },
    cartUrl() {
      return `${this.trekBrandNavURL}/cart`;
    },
  },
  created() {
    if (this.isRestrictedToRetailer) {
      this.fetchUserCompetency();
    }
  },
  methods: {
    ...mapMutations('user', ['updateTrekUCompetency']),

    async fetchUserCompetency() {
      try {
        const competency = await UserOccApi.getUserCompetency(this.occUrlParams.userId);
        this.updateTrekUCompetency(competency);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
:deep(.pdl-collapse-item__wrap) {
  border-bottom: none;
}

:deep(.pdl-collapse-item__header) {
  border-bottom: none;
}

:deep(.pdl-media-object-list) {
  border: none;
}

:deep(.pdl-media-object-list .pdl-media-object:not(:last-child)) {
  border-bottom: none;
}

:deep(.button + .button) {
  margin-top: 0.25rem;
}
</style>
